export const isServerSide = () => {
  return typeof window === 'undefined';
};

export const isEven = (value: number) => value % 2 == 0;

export const formatPrice = (price: number) => `${price?.toLocaleString()} €`;
